module.exports = __webpack_public_path__ + "b/static/img/top.1a8b7128.png";